<template>
  <div>
    <v-autocomplete
      @keyup="setRealEstateSearch"
      @change="applyFilter"
      @click:clear="clearFilter"
      :label="$t('genericFilters.label.customer')"
      :no-data-text="$t('appointment.filters.noData')"
      :prepend-inner-icon="icon"
      :loading="isRealEstateLoading"
      :clearable="clearable"
      :items="customers"
      item-text="name"
      item-value="id"
      return-object
      hide-no-data
      single-line
      outlined
      dense
    >
      <template v-slot:selection="data">
        <span class="d-block text-truncate">
          {{ data.item.name }}
        </span>
      </template>
      <template v-slot:item="data">
        {{ data.item.name }}
      </template>
    </v-autocomplete>
  </div>
</template>
<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import store from '@/store'
export default {
  name: 'RealEstateSelectFilter',
  props: {
    fetchData: {
      type: Function,
      required: true,
    },

    clearable: {
      type: Boolean,
      required: false,
      default: true
    },

    icon: {
      type: String,
      required: false,
      default: 'mdi-magnify',
    },
  },
  data() {
    return {
      timer: null,
      isRealEstateLoading: false,
    }
  },
  computed: {
    ...mapGetters(['customers', 'filters']),
  },

  methods: {
    ...mapActions(['fetchCustomers']),
    ...mapMutations(['setFilters', 'setCurrentPage']),

    setRealEstateSearch({ target }) {
      this.isRealEstateLoading = true

      clearTimeout(this.timer)

      this.timer = setTimeout(() => {
        this.fetchCustomers(target.value).finally(() => {
          this.isRealEstateLoading = false
        })
      }, 500)
    },

    applyFilter(realEstate) {
      if (realEstate) {
        Promise.resolve(
          this.setFilters({ ...store.getters.filters, ...{ realEstateId: realEstate.id },})
        )
        .then(() => this.setCurrentPage(1))
        .then(() => { this.fetchData()
          this.$emit('filterChange')
        })
      }
    },

    clearFilter() {
      this.isRealEstateLoading = false
      this.setFilters({
        ...this.$store.getters.filters,
        ...{ realEstateId: null },
      })
      this.fetchData()
      this.$emit('filterChange')
    },
  },
}
</script>
